import { store } from '../store'

export default (to, from, next) => {
  console.log('auth')
  if (store.getters.user) {
    next()
  } else {
    next('/signin?returnURL=' + to.path)
  }
}



// WEBPACK FOOTER //
// ./src/router/AuthGuard.js